export default "__VITE_ASSET__SFau7uU0__"